import { RootState } from "../../reducers";
import { DATES_MAP } from "../../constants";
import { getKeyByValue } from "../../utils";
import { SelectorTitle, SelectorName, SelectorInputOption } from "../../styles/SelectorStyles";
import { useSelector, useDispatch } from "react-redux";
import { sendAnalyticsEvent } from "../../utils/sendAnalyticMessages";

function DateSelector(): JSX.Element {
  const filterStore = useSelector((state: RootState) => state.filter);
  const dispatch = useDispatch();
  const dates: string[] = Array.from(DATES_MAP.values());

  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  return (
    <div>
      <SelectorTitle>
        Select A Date
      </SelectorTitle>
      {
        dates.map((i) => (
          <SelectorInputOption key={i} onClick={() => {
            dispatch({
              type: "SET_DATE_FILTER",
              payload: getKeyByValue(DATES_MAP, i),
            });
            dispatch({
              type: "SET_SELECTED_FILTER",
              payload: '',
            });
            sendAnalyticsEvent(
              {
                event: "smart_picks_date_select",
                selection: getKeyByValue(DATES_MAP, i),
              },
              parentURL
            );
          }}>
            <SelectorName>{i}</SelectorName>
            <div>
              <input
                readOnly
                type="radio"
                id={i}
                name="date"
                value={i}
                checked={filterStore.date === getKeyByValue(DATES_MAP, i)}
              />
            </div>
          </SelectorInputOption>
        ))
      }
    </div>
  );
}

export default DateSelector;
